import { Emblem, type EmblemName } from './brand/Emblems'
import { cx } from './cx'

export type GaugeKind = 'hp' | 'st' | 'mn' | 'xp'

const KIND: Record<GaugeKind, { cls: string; emblem: EmblemName; label: string }> = {
  hp: { cls: '', emblem: 'res.hp', label: 'Здоровье' },
  st: { cls: 'gauge--st', emblem: 'res.stamina', label: 'Выносливость' },
  mn: { cls: 'gauge--mn', emblem: 'res.mana', label: 'Мана' },
  xp: { cls: 'gauge--xp', emblem: 'res.xp', label: 'Опыт' },
}

export type GaugeProps = { kind: GaugeKind; value: number; max: number; label?: string; hint?: string; showIcon?: boolean; className?: string }

/** Horizontal resource bar: forged trough, glass fill, number on the right. */
export function Gauge({ kind, value, max, label, hint, showIcon = true, className }: GaugeProps) {
  const k = KIND[kind]
  const safeMax = Math.max(0, max)
  const now = Math.min(Math.max(0, value), safeMax)
  const pct = safeMax > 0 ? Math.round((now / safeMax) * 100) : 0
  const name = label ?? k.label
  return (
    <div className={cx('gauge', k.cls, className)} role="meter" aria-label={name} aria-valuemin={0} aria-valuemax={safeMax} aria-valuenow={now} aria-valuetext={`${name}: ${now} из ${safeMax}${hint ? `, ${hint}` : ''}`} title={hint}>
      {showIcon && <Emblem name={k.emblem} />}
      <div className="gauge__trough">
        <div className="gauge__fill" style={{ width: `${pct}%` }} />
        <div className="gauge__num" aria-hidden="true">{now}<small>/{safeMax}</small></div>
      </div>
    </div>
  )
}

export type Resource = { kind: GaugeKind; value: number; max: number; label?: string; hint?: string }

/** Any number of resources: resources with max ≤ 0 are not shown. */
export function Gauges({ resources, className }: { resources: Resource[]; className?: string }) {
  return (
    <div className={cx('gauges', className)}>
      {resources.filter(r => r.max > 0).map(r => <Gauge key={r.kind} {...r} />)}
    </div>
  )
}
